import { ca } from '@cian/analytics';

export function trackCrosslinksClick(): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Listing',
    label: 'nearby_metro',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackCrosslinksShown(): void {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Listing',
    label: 'nearby_metro',
    name: 'oldevent',
    useLastProducts: true,
  });
}
